const apiVersion = 'v1'

export const BASE_PATH = `api/${apiVersion}/users/`
